import { render, staticRenderFns } from "./airlinedetails.vue?vue&type=template&id=8113bb04&scoped=true&"
import script from "./airlinedetails.vue?vue&type=script&lang=js&"
export * from "./airlinedetails.vue?vue&type=script&lang=js&"
import style0 from "./airlinedetails.vue?vue&type=style&index=0&id=8113bb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8113bb04",
  null
  
)

export default component.exports